import { useConfig } from "../ConfigContext";

export default function Receipt({ caseData, payment }) {
  const { config, error: configError } = useConfig();

  return (  
    <div style={{width:'100%'}}>
        { payment.apt_transactionresult === 'Accepted' && <h3>
            Thank you for your payment
            </h3> }
        { payment.apt_transactionresult !== 'Accepted' && <h3 style={{color:'red'}}>
            Your payment has been declined
            </h3> }
        { payment.apt_email && <>
          { payment.apt_transactionresult !== 'Accepted' && <p>
            The penalty amount has not been paid and your case remains open. 
            </p> } 
          <p>
            A receipt of the { payment.apt_transactionresult === 'Accepted' ? 'payment' : 'transaction' } has been emailed to the address you provided
          </p>
          </> }

      <div className="display-only-item--inline">
        <label>Penalty Order Number:</label>
        <div className="value">
          {caseData.apt_number}
        </div>
      </div>
      
      <div className="display-only-item--inline">
        <label>Transaction Confirmation Number:</label>
        <div className="value">
          {payment.apt_transactionordernumber}
        </div>
      </div>
      
      <div className="display-only-item--inline">
        <label>Credit Card Number:</label>
        <div className="value">
          **** **** **** { payment.apt_creditcardlastfourdigits }
        </div>
      </div>
      
      { payment.apt_transactionresult === 'Accepted' && <div className="display-only-item--inline">
        <label>Amount Paid:</label>
        <div className="value">
          { config.currencyFormatter.format(payment.apt_amount)}
        </div>
      </div> }
      
      { payment.apt_transactionresult === 'Accepted' && <div className="display-only-item--inline">
        <label>Case Status:</label>
        <div className="value">
          Paid
        </div>
      </div> }
    </div>
  );
}